import { MCs } from 'src/components/mc-list/mcs/MCs'
import React from 'react'

export const MCsPage = () => {
  return <MCs />
}
